import React from 'react';
import { TranscriptTimeRangeContextType } from './types';

const TranscriptTimeRangeContext = React.createContext<
  TranscriptTimeRangeContextType | undefined
>(undefined);

export default TranscriptTimeRangeContext;
